import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Gray_Outline_Button.css";

const Gray_Outline_Button = ({
  btnText,
  onClick,
  type = "button",
  ...rest
}) => {
  return (
    <section className="Gray_Outline_Button_holder">
      <Button
        className="Gray_Outline_Button"
        type={type}
        onClick={onClick}
        {...rest}
      >
        <span className="btn_name">{btnText}</span>
      </Button>
    </section>
  );
};

export default Gray_Outline_Button;
